////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const userPreferences = {
	getUserPreferences: () => ({
		type: ActionsTypes.GET_USER_PREFERENCES,
	}),
	getUserPreferencesSuccess: (data) => ({
		type: ActionsTypes.GET_USER_PREFERENCES_SUCCESS,
		payload: {
			data,
		},
	}),
	getUserPreferencesFailure: (error) => ({
		type: ActionsTypes.GET_USER_PREFERENCES_FAILURE,
		payload: {
			error,
		},
	}),
	setUserPreference: (idPreference, typeURL, selected) => ({
		type: ActionsTypes.SET_USER_PREFERENCE,
		payload: {
			idPreference,
			typeURL,
			selected,
		},
	}),
	setUserPreferenceSuccess: (data, typeURL) => ({
		type: ActionsTypes.SET_USER_PREFERENCE_SUCCESS,
		payload: {
			data,
			typeURL,
		},
	}),
	setUserPreferenceFailure: (error) => ({
		type: ActionsTypes.SET_USER_PREFERENCE_FAILURE,
		payload: {
			error,
		},
	}),

	setIsActivedPreference: (bool) => ({
		type: ActionsTypes.SET_IS_ACTIVED_PREFERENCE,
		payload: {
			bool,
		},
	}),
}

export default userPreferences
